import axios from 'axios';
import { clearAuthSession, loadAuthSession, saveAuthSession, verifyToken } from 'contexts/auth/session';

export const GESTOP_API_BASE_URL = process.env.REACT_APP_API;
export const GESTOP_CONNECTION_NAME = process.env.REACT_APP_CONN;

const gestopAPI = axios.create({
    baseURL: GESTOP_API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        'X-ConnName': GESTOP_CONNECTION_NAME
    }
});

const gestopApiWithoutHeader = (headers) => {
    const HEADERS = headers || {};

    return axios.create({
        baseURL: GESTOP_API_BASE_URL,
        headers: {
            'X-ConnName': GESTOP_CONNECTION_NAME,
            ...HEADERS
        },
        withCredentials: true
    });
};

const gestopApiForExternalEndpoints = axios.create({
    baseURL: GESTOP_API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        'X-ConnName': GESTOP_CONNECTION_NAME
    }
});

// Set the AUTH token for any request
gestopAPI.interceptors.request.use(async (config) => {
    const token = localStorage.getItem('serviceToken');
    const signOut = () => {
        clearAuthSession();
        window.location.href = '/login';
    };

    if (token && verifyToken(token)) {
        config.headers.Authorization = `Bearer ${token}`;
    } else {
        const refreshToken = localStorage.getItem('refreshToken');

        if (refreshToken) {
            try {
                const responseRefreshToken = await fetch(`${process.env.REACT_APP_API}security/refreshtoken`, {
                    body: JSON.stringify({ refresh_token: refreshToken }),
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-ConnName': process.env.REACT_APP_CONN
                    }
                });

                if (responseRefreshToken.status === 200) {
                    const data = await responseRefreshToken.json();
                    const currentSession = loadAuthSession();

                    saveAuthSession({
                        ...(currentSession || {}),
                        serviceToken: data.token,
                        refreshToken: data.refresh_token || refreshToken
                    });

                    config.headers.Authorization = `Bearer ${data.token}`;
                } else {
                    signOut();
                }
            } catch (error) {
                // eslint-disable-next-line no-empty
            }
        }

        // if intercepted request has unauthorized status code then sign out
        if (config?.response?.status === 401) {
            signOut();
        }

        // eslint-disable-next-line no-underscore-dangle
        config._retry = true;
        return config;
    }

    return config;
});

export { gestopApiForExternalEndpoints, gestopApiWithoutHeader };
export default gestopAPI;
